module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/keyboards-and-synths-7bd50b3e053d86bc0da7d52a05a78c9e.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/keyboards-and-synths.png
// module id = okhN
// module chunks = 12 16 18